(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/init.js');
"use strict";


svs.eInstant.logger = new svs.core.log.Logger('module:e-instant-react');
const Router = svs.app.ReactRouter.PlayerRouter;
const {
  Route
} = svs.app.ReactRouter;
const {
  LOBBY,
  GAME_INFO,
  PLAY,
  DEMO_PLAY,
  BET_DETAIL
} = svs.eInstant.constants.ROUTES;
const EInstantRouter = () => {
  const {
    Info
  } = svs.eInstant.info;
  const {
    Lobby
  } = svs.eInstant.lobby;
  const {
    Play
  } = svs.eInstant.play;
  return React.createElement(Router, {
    basename: svs.core.data.baseUrl
  }, React.createElement(Route, {
    component: Lobby,
    exact: true,
    path: LOBBY
  }), React.createElement(Route, {
    component: Info,
    exact: true,
    path: GAME_INFO
  }), React.createElement(Route, {
    component: Play,
    exact: true,
    path: PLAY
  }), React.createElement(Route, {
    component: Play,
    exact: true,
    path: DEMO_PLAY
  }), React.createElement(Route, {
    component: Play,
    exact: true,
    path: BET_DETAIL
  }));
};
const target = document.getElementById('reactContainer');
target && ReactDOM.render(React.createElement(EInstantRouter, null), target);

 })(window);